export default [
  {
    name: 'firstLine',
    fields: [
      { type: 'checkboxGroup', name: 'servicos_interesse', label: 'Serviços de interesse', isRequired: true }
    ]
  }
];
